import React, { Component } from 'react';
import { compose,range, reduce, toUpper } from 'ramda';
import { connect } from 'react-redux';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './DatepickerService';
import Datepicker, {DATEPICKER_TYPES} from '@synergycms_core/components/generic/Datepicker';
import DaySelector from '../Datepicker/DaySelector';
import actions from '../../../store/actions';
import { Map, OrderedMap, List } from 'immutable';
import { addServiceByTime } from '../../../utils/services';

import moment from 'moment';
import {
  SERVICE_TYPE_PER_PERSON,
  SERVICE_TYPE_PER_PERSON_NIGHT,
  SERVICE_TYPE_PER_STAY,
  SERVICE_PER_PERSON_TYPES, 
  SERVICE_PER_NIGHT_TYPES, 
  SERVICE_TYPE_PER_USE
} from '../../../config/constants';

const mapStateToProps = (store, ownProps) => {
  return {
    params : store.getIn(['customer', 'params', 'params'])
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addServiceByTime: serviceBlocks => {
      dispatch(actions.customer.reservationRequest.addServiceByTime(serviceBlocks));
    },
    addService: serviceBlocks => {
      dispatch(actions.customer.reservationRequest.addService(serviceBlocks));
    },
    removeService: serviceBlocks => {
      dispatch(actions.customer.reservationRequest.removeService(serviceBlocks));
    }
  };
}


export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'service',
    'params',
    'blockIdx',
    'addServiceByTime',
    'addService',
    'reservationBlocks',
    'removeService',
    'selectedBlock',
    'selectedDates',
    'changeSelectedDates',
    'remainingQuota'
  ]),
  withThemeJSS({ styleFile, link: true })
)(class DatepickerService extends Component {
  static displayName = 'DatepickerService';

  constructor(props) {
    super(props);
    const { params } = props.config;

    this.reservationDays = reduce((result, day) => {
      result[moment(params.get("date")).add(day,"day").format('YYYY-MM-DD')] = true;
      return result;
    }, {}, range(0, params.get("stay_length")));

  }

  onOptionSelect = (date) => {
    const {
      service,
      blockIdx,
      addServiceByTime: addServiceByTimeFn,
      reservationBlocks
    } =  this.props.config;

    addServiceByTime(
      blockIdx, 
      service, 
      reservationBlocks, 
      date, 
      addServiceByTimeFn
    );
  }

  serviceTypeDayCondition = ({stringDate}) => {

    const {
      service,
      blockIdx,
      reservationBlocks,
      remainingQuota
    } = this.props.config;

    const worksWithQuotaTime = !!service.get("works_with_quota_time");

    const serviceType = toUpper(service.get("type"));
    const isPerson = serviceType === SERVICE_TYPE_PER_PERSON
    const isNightType = SERVICE_PER_NIGHT_TYPES.includes(serviceType);;
    const isPersonNight = serviceType === SERVICE_TYPE_PER_PERSON_NIGHT;
    const isStay = serviceType === SERVICE_TYPE_PER_STAY;
    const isUse = serviceType === SERVICE_TYPE_PER_USE;

    const block = reservationBlocks.find(block => block.get('idx') === blockIdx);
    const services = block.get('services', List());
    const selectedService = services.find(serviceBlock => serviceBlock.get('service_id') === service.get('id'));

    // Si el dia no pertenece a la estadia lo deshabilitamos directamente
    if(!this.reservationDays[stringDate]) {
      return true;
    }

    // Si trabajamos con cuotas por hora, verificamos si el dia tiene alguna cuota disponible
    let dayHasQuotaHour = false;
    if(worksWithQuotaTime) {
      const hours = Array.from({ length: 24 }, (_, i) => moment({ hour: i }).format('HH:mm:ss'));
      hours.forEach(hour => {
        const compareDate = moment(stringDate + ' ' + hour);
        if(remainingQuota[compareDate.format('YYYY-MM-DD-HH:mm:ss')]) {
          dayHasQuotaHour = true;
        }
      });
    }

    // Si es la primera vez que se carga el bloque, deshabilitamos los dias que no tengan cuota simplemente
    if (!services.size) {
      let limitQuota = 0;
      if(isPerson || isPersonNight) limitQuota = block.get('adults') + block.get('childs', 0);
      return worksWithQuotaTime ? !dayHasQuotaHour : !remainingQuota[stringDate] || remainingQuota[stringDate] < limitQuota;    
    }

    // Si el servicio ya ha sido seleccionado previamente, controlamos las casuisticas adicionales para deshabilitar los días
    // Por ejemplo: El suplemento por estancia solo se puede seleccionar una vez, entonces si ya ha sido añadido una vez, deshabilitamos los demas días
    if(selectedService) {

      if(isUse) {
        return !this.reservationDays[stringDate] || remainingQuota[stringDate] <= 0;
      }
      
      if(isNightType) {
        const serviceDates = selectedService.get('dates');
        return !this.reservationDays[stringDate] || serviceDates.find(date => date.get('day') === stringDate) || remainingQuota[stringDate] <= 0;
      }

      
      if(isPerson || isPersonNight) {
        const totalQuotaPerPerson = block.get('adults') + block.get('childs', 0);
        const hasRemainingQuota = remainingQuota[stringDate] && remainingQuota[stringDate] >= totalQuotaPerPerson;
        const serviceDates = selectedService.get('dates');
        
        return worksWithQuotaTime ? 
        !this.reservationDays[stringDate] || !dayHasQuotaHour : 
        !this.reservationDays[stringDate] || serviceDates.find(date => date.get('day') === stringDate) || !hasRemainingQuota;

      }

      if(isStay) {
        return !this.reservationDays[stringDate] || selectedService ||  remainingQuota[stringDate] <= 0;
      }

    }

    return remainingQuota[stringDate] <= 0;
  };

  onChangeCalendar = (dateObj) => {

    const {
      service,
      blockIdx,
      addService,
      removeService,
      reservationBlocks,
      changeSelectedDates
    } = this.props.config;

    const { dates } = dateObj;

    if(service.get('works_with_quota_time', false)) {
      return;
    }

    changeSelectedDates(blockIdx, dates, () => {

      this.serviceBlock = OrderedMap();
      let serviceDates = List();

      const block = reservationBlocks.find(block => block.get('idx') === blockIdx);
      const selectedService = block.get('services', List()).find(serviceBlock => {
        return serviceBlock.get('service_id') === service.get('id');
      });

      const serviceType = service.get('type').toUpperCase();

      dates.forEach(date => {
        
        const datePrice = service.get('days').find(day => day.get('day') === date);
        
        let serviceQuantity = 1;
        if(SERVICE_PER_PERSON_TYPES.includes(serviceType)) {
          serviceQuantity = block.get('adults') + block.get('childs', 0);
        }

        if(selectedService) {
          const serviceSelectedDates = selectedService.get('dates');
          const actualDate = serviceSelectedDates.find(dateSelected => dateSelected.get('day') === date);
          const quantity = actualDate ? actualDate.get('quantity') : serviceQuantity;
          serviceDates = serviceDates.push(Map({
            "quantity": quantity,
            "day": date,
            "price": datePrice.get('price') * quantity
          }));
        } else {
          serviceDates = serviceDates.push(Map({
            "quantity": serviceQuantity,
            "day": date,
            "price": datePrice.get('price') * serviceQuantity
          }));
        }
      });

      if(!dates.length) {
        removeService(OrderedMap().set(
          blockIdx, Map({
            service_id: service.get('id')
          }))
        );
      } else {
        const quantity = serviceDates.reduce((total, date) => total + date.get('quantity'), 0);
        const price = serviceDates.reduce((total, date) => total + date.get('price'), 0);
        this.serviceBlock = this.serviceBlock.set(
          blockIdx,
          Map({
            service_id: service.get('id'),
            price: price,
            quantity: quantity,
            dates: serviceDates
          })
        );
        addService(this.serviceBlock);
      }
    });
  }

  render() {

    const { config, theme } = this.props;
    const {
      params,
      service,
      blockIdx,
      reservationBlocks,
      selectedBlock,
      selectedDates,
    } = config;

    const worksWithQuotaTime = !!service.get("works_with_quota_time");

    const serviceType = toUpper(service.get("type"));
    const isPerson = serviceType === SERVICE_TYPE_PER_PERSON;
    const isPersonNight = serviceType === SERVICE_TYPE_PER_PERSON_NIGHT;

    let datepickerType =  worksWithQuotaTime ? DATEPICKER_TYPES.SINGLE : DATEPICKER_TYPES.MULTI;

    let daySelectorOptions = [];

    if(worksWithQuotaTime) {
      daySelectorOptions = service.get('days').reduce((selectorOptions, day) => {
        selectorOptions[day.get('day')] = day.get('quotas_time').reduce((timeOptions, time) => {
          
          let currentBlock;
          const spentQuota = reservationBlocks.reduce((total, block) => {
            
            if(block.get('idx') === blockIdx) {
              currentBlock = block;
            }

            const serviceBlock = block.get('services', List()).find(
              serviceBlock => serviceBlock.get('service_id') === service.get('id')
            );

            if(!serviceBlock) return total;

            const serviceDates = serviceBlock.get('dates');
            const date = serviceDates.find(
              date => date.get('day') === day.get('day') && date.get('time') === time.get('time')
            );

            if(!date) return total;

            if(date.get('time') === time.get('time')) {
              return total + date.get('quantity');
            }

            return total;
          }, 0);

          const remainingQuota = time.get('quota') - spentQuota;

          let isDisabled = remainingQuota <= 0;

          if(isPerson || isPersonNight) {
            const totalOccup = currentBlock.get('adults') + currentBlock.get('childs', 0);
            isDisabled = remainingQuota < totalOccup;

            if(!isDisabled) {
              const currentBlock = reservationBlocks.find(block => block.get('idx') === blockIdx);
              const currentService = currentBlock.get('services', List()).find(
                serviceBlock => serviceBlock.get('service_id') === service.get('id')
              );

              if(currentService) {
                const serviceDates = currentService.get('dates');
                const date = serviceDates.find(date => date.get('day') === day.get('day') && date.get('time') === time.get('time'));
                if(date) {
                  isDisabled = true;
                }
              }
            }
          }

          timeOptions.push({
            value: moment(time.get('time'), 'HH:mm:ss').format('HH:mm'),
            label: moment(time.get('time'), 'HH:mm:ss').format('HH:mm'),
            isDisabled: isDisabled
          });

          return timeOptions;
        }, []).sort((a, b) => {
          const timeA = moment(a.value, 'HH:mm');
          const timeB = moment(b.value, 'HH:mm');
          return timeA - timeB;
        });
        return selectorOptions;
      }, {});
    }

    const isCurrentBlock = selectedBlock === blockIdx;
    const requiresCustomModel = !worksWithQuotaTime;
    const isMobile = theme.deviceType === 'MOBIL';

    let preSelected = false;

    if(worksWithQuotaTime && SERVICE_PER_NIGHT_TYPES.includes(serviceType)) {
      preSelected = true;
    }

    return (
      <Datepicker
        months={isMobile ? 1 : 2}
        mobileArrows={isMobile ? true : false}
        enableScrollEvent={false}
        minDate={moment()}
        innerStyle={[isCurrentBlock ? 'noAvailAlertDatepicker' : 'hideDatepicker', theme.computedInnerStyle]}
        typeSelection={{type: datepickerType}}
        firstMonth={moment(params.get("date"))}
        onRangeChange={this.onChangeCalendar}
        disableDay={this.serviceTypeDayCondition}
        customDatesModel={requiresCustomModel ? selectedDates[blockIdx] : undefined}
        daySelectorOptions={daySelectorOptions}
        onOptionSelect={this.onOptionSelect}
        DaySelectorTemplate={!!worksWithQuotaTime ? (props => <DaySelector {...props} preSelected={preSelected} />) : false}
        isQuotaService={true}
      />
    );
  }
});
